// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__16u7s","image":"Header_image__ECV8o","name":"Header_name__7zJ4R","info":"Header_info__iD_ky","infoRow":"Header_infoRow__2oG08"};